import {Action} from '@ngrx/store';
import {AusmitError} from "../../shared/interfaces";

export enum ActionTypes {
	LocationByLatLong = 'LocationByLatLong',
	LocationByLatLongSuccess = 'LocationByLatLongSuccess',
	LocationByLatLongError = 'LocationByLatLongError',

	GetShopCountByLocation = 'GetShopCountByLocation',
	GetShopCountByLocationSuccess = 'GetShopCountByLocationSuccess',
	GetShopCountByLocationError = 'GetShopCountByLocationError',

	MarketplaceAnalytics = 'MarketplaceAnalytics',
	MarketplaceAnalyticsSuccess = 'MarketplaceAnalyticsSuccess',
	MarketplaceAnalyticsError = 'MarketplaceAnalyticsError',
}

export class LocationByLatLong implements Action {
	readonly type = ActionTypes.LocationByLatLong;

	constructor(public payload: { latitude: number, longitude: number }) {
	}
}

export class LocationByLatLongSuccess implements Action {
	readonly type = ActionTypes.LocationByLatLongSuccess;

	constructor(public payload: any) {
	}
}

export class LocationByLatLongError implements Action {
	readonly type = ActionTypes.LocationByLatLongError;

	constructor(public payload: AusmitError) {
	}
}

export class GetShopCountByLocation implements Action {
	readonly type = ActionTypes.GetShopCountByLocation;

	constructor(public payload?: any) {
	}
}

export class GetShopCountByLocationSuccess implements Action {
	readonly type = ActionTypes.GetShopCountByLocationSuccess;

	constructor(public payload: any) {
	}
}

export class GetShopCountByLocationError implements Action {
	readonly type = ActionTypes.GetShopCountByLocationError;

	constructor(public payload: AusmitError) {
	}
}

export class MarketplaceAnalytics implements Action {
	readonly type = ActionTypes.MarketplaceAnalytics;

	constructor(public payload?: any) {
	}
}

export class MarketplaceAnalyticsSuccess implements Action {
	readonly type = ActionTypes.MarketplaceAnalyticsSuccess;

	constructor(public payload: any) {
	}
}

export class MarketplaceAnalyticsError implements Action {
	readonly type = ActionTypes.MarketplaceAnalyticsError;

	constructor(public payload: AusmitError) {
	}
}

export type Actions =
	| LocationByLatLong
	| LocationByLatLongSuccess
	| LocationByLatLongError
	| GetShopCountByLocation
	| GetShopCountByLocationSuccess
	| GetShopCountByLocationError
	| MarketplaceAnalytics
	| MarketplaceAnalyticsSuccess
	| MarketplaceAnalyticsError;

